import { Routes, Route } from 'react-router-dom';
import { PeopleListPage } from './people-list-page';
import { AddEmployeePage } from './add-employee-page';
import { EditEmployeePage } from './edit-employee-page';
import { PeopleImportWizardPage } from './import/people-import-wizard-page';
import { TechDetailPage } from '../crew/techs/tech-detail-page';

export function PeoplePage() {
  return (
    <Routes>
      <Route index element={<PeopleListPage basePath="/people" />} />
      <Route path="new" element={<AddEmployeePage basePath="/people" />} />
      <Route path="import" element={<PeopleImportWizardPage basePath="/people" />} />
      <Route path=":id/edit" element={<EditEmployeePage basePath="/people" />} />
      <Route path=":id" element={<TechDetailPage basePath="/people" />} />
    </Routes>
  );
}
